import { connect } from 'react-redux';
import { selectors, actions } from '../../../Stream';
const mapStateToProps = (state, { direction , streamId  })=>{
    return {
        hasMore: selectors.getHasMoreInDirection(state, streamId, direction),
        isFetching: selectors.isFetching(state, streamId)
    };
};
const mapDispatchToProps = (dispatch, { streamId , direction  })=>({
        onLoadMore: ()=>dispatch(actions.fetch(streamId, direction))
    });
export default connect(mapStateToProps, mapDispatchToProps);
